<section>
  <h3 class="text-3 bold-1">{{ header() }}</h3>
  <p class="text-4">{{ subheader() }}</p>
</section>

<img [ngSrc]="src()" [alt]="alt()" [priority]="priority()" height="120" width="200">
